export default __webpack_public_path__ + "static/media/merinmary-basil.9207901b.jpg";